
import React from 'react';
import './Siseriesplaten.css';
import SISeriesplaten from '../../../imgs/SISeriesplaten.webp'; 

const Siseriesplaten = () => {
  return (
    <div className="Siseriesplat-container"data-aos="fade-down">
      <img src={SISeriesplaten} alt="Fitting Corrosion" className="Siseriesplat-image" />
    </div>
  );
};

export default Siseriesplaten;
 